/* Reading progress bar for the article template. */
class ArticleReadingProgress extends HTMLElement {
  constructor() {
    super();
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    this.bar = this.querySelector('.article-progress__bar');
    this.target = document.getElementById(this.dataset.target);

    if (!this.bar || !this.target) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;

    const rect = this.target.getBoundingClientRect();
    const viewport = window.innerHeight;
    const readable = rect.height - viewport;
    const started = rect.top <= 0;
    const finished = rect.bottom <= viewport;

    let progress = 0;
    if (readable > 0) {
      progress = Math.min(Math.max(-rect.top / readable, 0), 1);
    } else if (finished) {
      progress = 1;
    }

    this.bar.style.transform = `scaleX(${progress})`;
    this.dataset.active = started && !finished ? 'true' : 'false';
  }
}

if (!customElements.get('article-reading-progress')) {
  customElements.define('article-reading-progress', ArticleReadingProgress);
}
